const location = () => (document.location.pathname + document.location.search);

const Type = {
    ANY:        0xFFFF,
    PAGE_VIEW:  0x0002,
    CLICK:      0x0004,
    CARRITO:    0x0008,
    CART:       0x0010,
    CHECKOUT:   0x0020,
    ERROR:      0x0040,
    EXTENSION:  0x0080,
    GENERAL:    0x0100,
    HOME:       0x0200,
    OCT8NE:     0x0400,
    ZOPIM:      0x0800,
};


const Event = {
    pageView: {
        type: Type.PAGE_VIEW,
        create: (action, page) =>({
            type: Type.PAGE_VIEW,
            ts: Date.now(),
            location: location(),
            page,
        })
    },

    click: {
        type: Type.CLICK,
        create: (action, page, label) => ({
            type: Type.CLICK,
            ts: Date.now(),
            location: location(),
            page,
            category: (() => {
                switch(page) {
                    case 'home':
                        return 'Home';
                    case 'product':
                        return 'Clicks Pagina Producto';
                    case 'category':
                        return 'Categoria';
                    case 'search':
                        return 'Clicks Pagina Busqueda';
                    default:
                        return 'PAGE_NOT_DETECTED';
                }
            })(),
            action,
            label,
        }),
    },

    carrito: {
        type: Type.CARRITO,
        create: (action, page) => ({
            type: Type.CARRITO,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Carrito',
            action,
        }),
    },

    cart: {
        type: Type.CART,
        create: (action, page) => ({
            type: Type.CART,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Cart',
            action,
        }),
    },

    checkout: {
        type: Type.CHECKOUT,
        create: (action, page) => ({
            type: Type.CHECKOUT,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Checkout',
            action,
        }),
    },

    error: {
        type: Type.ERROR,
        create: (action, page) => ({
            type: Type.ERROR,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Error',
            action,
        }),
    },

    extension: {
        type: Type.EXTENSION,
        create: (action, page) => ({
            type: Type.EXTENSION,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Extension',
            action,
        }),
    },

    general: {
        type: Type.GENERAL,
        create: (action, page) => ({
            type: Type.GENERAL,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'general',
            action,
        }),
    },

    home: {
        type: Type.HOME,
        create: (action, page) => ({
            type: Type.HOME,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Home',
            action,
        }),
    },

    oct8ne: {
        type: Type.OCT8NE,
        create: (action, page) => ({
            type: Type.OCT8NE,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Oct8ne',
            action,
        }),
    },

    zopim: {
        type: Type.ZOPIM,
        create: (action, page) => ({
            type: Type.ZOPIM,
            ts: Date.now(),
            location: location(),
            page: page,
            category: 'Zopim Livechat',
            action,
        }),
    },
};

export {
    Type,
    Event,
    location,
};
